// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-attributes-CustomViewAttributes-module-multipleAttributesButton {
	-ms-flex-align: center;
	    align-items: center;
	border-top: 1px solid var(--Grey400);
	cursor: pointer;
	display: -ms-flexbox;
	display: flex;
	font-weight: 600;
	height: 44px;
	-ms-flex-pack: center;
	    justify-content: center;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-addMultipleAttributesText {
	color: var(--Blue600);
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-removeMultipleAttributesText {
	color: var(--Red600);
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-attribute {
	border: 1px solid var(--Grey300);
	border-radius: 4px;
	gap: 4px;
	height: 40px;
	min-width: 0;
	padding: 0 8px;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-selectionsHeader {
	padding: 12px 0 8px;
	top: 0;
	z-index: 1;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-hoverButton {
	visibility: hidden;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-toggleHiddenButton {
	display: none;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-selection:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-hiddenButton {
	display: none;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-selection:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-toggleHiddenButton {
	display: -ms-inline-flexbox;
	display: inline-flex;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-attributeHoverReplaceIcon {
	display: none;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-attributeAddIcon {
	color: var(--Blue600);
}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-attributeRemoveIcon {
	color: var(--Red600);
}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute {
	gap: 4px;
	height: 40px;
	padding-right: 24px;			
}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute:hover {
		background-color: var(--Blue30);
	}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-attributeActionIcon {
			background: none;
		}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-attributeCheckIcon {
			display: none;
		}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-attributeHoverReplaceIcon {
			display: inherit;
		}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-hoverButton {
			visibility: visible;
		}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-container {
	color: var(--Black100);
	gap: 4px;
	height: 32px;
	margin: 4px 20px;
}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-container:hover {
		cursor: pointer;
	}	

.csi-middleware-customView-attributes-CustomViewAttributes-module-container > svg {
		color: inherit;
	}

.csi-middleware-customView-attributes-CustomViewAttributes-module-selectedAttribute:hover {
		background-color: var(--Grey100);
	}

/* groups */
.csi-middleware-customView-attributes-CustomViewAttributes-module-groupBorder {
	border: 1px solid var(--Grey400);
	border-radius: 9px;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-groupText {
	font-size: 14px;
	font-weight: bold;
	height: 100%;
	line-height: 20px;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-groupAction {
	color: var(--Orange500);
	padding-right: 0;
	visibility: hidden;
	white-space: nowrap;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-group {
	color: var(--Black100);
	gap: 4px;
	height: 32px;
	margin: 4px 0;
	padding: 0 24px;
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-attributeGroup:hover {
		background-color: var(--Orange50);
	}

.csi-middleware-customView-attributes-CustomViewAttributes-module-attributeGroup:hover .csi-middleware-customView-attributes-CustomViewAttributes-module-hoverButton {
			background: none;
			visibility: visible;
		}

.csi-middleware-customView-attributes-CustomViewAttributes-module-groupedAttribute {
	padding-left: 20px;
}

/* background color */

.csi-middleware-customView-attributes-CustomViewAttributes-module-blueBackground {
	background-color: var(--Blue50);
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-whiteBackground {
	background-color: var(--PrimaryWhite);
}

.csi-middleware-customView-attributes-CustomViewAttributes-module-greyBackground {
	background-color: var(--Grey100);
}
`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/attributes/CustomViewAttributes.module.css"],"names":[],"mappings":"AAAA;CACC,sBAAmB;KAAnB,mBAAmB;CACnB,oCAAoC;CACpC,eAAe;CACf,oBAAa;CAAb,aAAa;CACb,gBAAgB;CAChB,YAAY;CACZ,qBAAuB;KAAvB,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,MAAM;CACN,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,2BAAoB;CAApB,oBAAoB;AACrB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,QAAQ;CACR,YAAY;CACZ,mBAAmB;AAqBpB;;AAnBC;EACC,+BAA+B;CAiBhC;;AAfC;GACC,gBAAgB;EACjB;;AAEA;GACC,aAAa;EACd;;AAEA;GACC,gBAAgB;EACjB;;AAEA;GACC,mBAAmB;EACpB;;AAIF;CACC,sBAAsB;CACtB,QAAQ;CACR,YAAY;CACZ,gBAAgB;AASjB;;AAPC;EACC,eAAe;CAChB;;AAEA;EACC,cAAc;CACf;;AAIA;EACC,gCAAgC;CACjC;;AAGD,WAAW;AACX;CACC,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,eAAe;AAChB;;AAGC;EACC,iCAAiC;CAMlC;;AAJC;GACC,gBAAgB;GAChB,mBAAmB;EACpB;;AAIF;CACC,kBAAkB;AACnB;;AAEA,qBAAqB;;AAErB;CACC,+BAA+B;AAChC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,gCAAgC;AACjC","sourcesContent":[".multipleAttributesButton {\n\talign-items: center;\n\tborder-top: 1px solid var(--Grey400);\n\tcursor: pointer;\n\tdisplay: flex;\n\tfont-weight: 600;\n\theight: 44px;\n\tjustify-content: center;\n}\n\n.addMultipleAttributesText {\n\tcolor: var(--Blue600);\n}\n\n.removeMultipleAttributesText {\n\tcolor: var(--Red600);\n}\n\n.attribute {\n\tborder: 1px solid var(--Grey300);\n\tborder-radius: 4px;\n\tgap: 4px;\n\theight: 40px;\n\tmin-width: 0;\n\tpadding: 0 8px;\n}\n\n.selectionsHeader {\n\tpadding: 12px 0 8px;\n\ttop: 0;\n\tz-index: 1;\n}\n\n.hoverButton {\n\tvisibility: hidden;\n}\n\n.toggleHiddenButton {\n\tdisplay: none;\n}\n\n.selection:hover .hiddenButton {\n\tdisplay: none;\n}\n\n.selection:hover .toggleHiddenButton {\n\tdisplay: inline-flex;\n}\n\n.attributeHoverReplaceIcon {\n\tdisplay: none;\n}\n\n.attributeAddIcon {\n\tcolor: var(--Blue600);\n}\t\n\n.attributeRemoveIcon {\n\tcolor: var(--Red600);\n}\t\n\n.containerAttribute {\n\tgap: 4px;\n\theight: 40px;\n\tpadding-right: 24px;\n\n\t&:hover {\n\t\tbackground-color: var(--Blue30);\n\n\t\t.attributeActionIcon {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t.attributeCheckIcon {\n\t\t\tdisplay: none;\n\t\t}\t\t\n\t\t\n\t\t.attributeHoverReplaceIcon {\n\t\t\tdisplay: inherit;\n\t\t}\t\t\n\t\t\n\t\t.hoverButton {\n\t\t\tvisibility: visible;\n\t\t}\n\t}\t\t\t\n}\t\n\n.container {\n\tcolor: var(--Black100);\n\tgap: 4px;\n\theight: 32px;\n\tmargin: 4px 20px;\n\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n\n\t> svg {\n\t\tcolor: inherit;\n\t}\n}\n\n.selectedAttribute {\n\t&:hover {\n\t\tbackground-color: var(--Grey100);\n\t}\n}\n\n/* groups */\n.groupBorder {\n\tborder: 1px solid var(--Grey400);\n\tborder-radius: 9px;\n}\n\n.groupText {\n\tfont-size: 14px;\n\tfont-weight: bold;\n\theight: 100%;\n\tline-height: 20px;\n}\n\n.groupAction {\n\tcolor: var(--Orange500);\n\tpadding-right: 0;\n\tvisibility: hidden;\n\twhite-space: nowrap;\n}\n\n.group {\n\tcolor: var(--Black100);\n\tgap: 4px;\n\theight: 32px;\n\tmargin: 4px 0;\n\tpadding: 0 24px;\n}\n\n.attributeGroup {\n\t&:hover {\n\t\tbackground-color: var(--Orange50);\n\t\t\n\t\t.hoverButton {\n\t\t\tbackground: none;\n\t\t\tvisibility: visible;\n\t\t}\n\t}\n}\n\n.groupedAttribute {\n\tpadding-left: 20px;\n}\n\n/* background color */\n\n.blueBackground {\n\tbackground-color: var(--Blue50);\n}\n\n.whiteBackground {\n\tbackground-color: var(--PrimaryWhite);\n}\n\n.greyBackground {\n\tbackground-color: var(--Grey100);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multipleAttributesButton": `csi-middleware-customView-attributes-CustomViewAttributes-module-multipleAttributesButton`,
	"addMultipleAttributesText": `csi-middleware-customView-attributes-CustomViewAttributes-module-addMultipleAttributesText`,
	"removeMultipleAttributesText": `csi-middleware-customView-attributes-CustomViewAttributes-module-removeMultipleAttributesText`,
	"attribute": `csi-middleware-customView-attributes-CustomViewAttributes-module-attribute`,
	"selectionsHeader": `csi-middleware-customView-attributes-CustomViewAttributes-module-selectionsHeader`,
	"hoverButton": `csi-middleware-customView-attributes-CustomViewAttributes-module-hoverButton`,
	"toggleHiddenButton": `csi-middleware-customView-attributes-CustomViewAttributes-module-toggleHiddenButton`,
	"selection": `csi-middleware-customView-attributes-CustomViewAttributes-module-selection`,
	"hiddenButton": `csi-middleware-customView-attributes-CustomViewAttributes-module-hiddenButton`,
	"attributeHoverReplaceIcon": `csi-middleware-customView-attributes-CustomViewAttributes-module-attributeHoverReplaceIcon`,
	"attributeAddIcon": `csi-middleware-customView-attributes-CustomViewAttributes-module-attributeAddIcon`,
	"attributeRemoveIcon": `csi-middleware-customView-attributes-CustomViewAttributes-module-attributeRemoveIcon`,
	"containerAttribute": `csi-middleware-customView-attributes-CustomViewAttributes-module-containerAttribute`,
	"attributeActionIcon": `csi-middleware-customView-attributes-CustomViewAttributes-module-attributeActionIcon`,
	"attributeCheckIcon": `csi-middleware-customView-attributes-CustomViewAttributes-module-attributeCheckIcon`,
	"container": `csi-middleware-customView-attributes-CustomViewAttributes-module-container`,
	"selectedAttribute": `csi-middleware-customView-attributes-CustomViewAttributes-module-selectedAttribute`,
	"groupBorder": `csi-middleware-customView-attributes-CustomViewAttributes-module-groupBorder`,
	"groupText": `csi-middleware-customView-attributes-CustomViewAttributes-module-groupText`,
	"groupAction": `csi-middleware-customView-attributes-CustomViewAttributes-module-groupAction`,
	"group": `csi-middleware-customView-attributes-CustomViewAttributes-module-group`,
	"attributeGroup": `csi-middleware-customView-attributes-CustomViewAttributes-module-attributeGroup`,
	"groupedAttribute": `csi-middleware-customView-attributes-CustomViewAttributes-module-groupedAttribute`,
	"blueBackground": `csi-middleware-customView-attributes-CustomViewAttributes-module-blueBackground`,
	"whiteBackground": `csi-middleware-customView-attributes-CustomViewAttributes-module-whiteBackground`,
	"greyBackground": `csi-middleware-customView-attributes-CustomViewAttributes-module-greyBackground`
};
module.exports = ___CSS_LOADER_EXPORT___;
